import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SellerSideBar from "../../components/seller/SellerSideBar/SellerSideBar";
import SellerTopBar from "../../components/seller/SellerTopBar/SellerTopBar";
import AppContext from "../../context/AppContext";
import "../../assets/css/seller/SellerMasterLayout/SellerMasterLayout.css";

const SellerMasterLayout = ({ children }) => {
  const location = useLocation();

  const {
    selectedScreenOfSellerDashboardSidebar,
    setAuthToken,
    setLoggedInAdmin,
    setLoggedInSeller,
  } = useContext(AppContext);

  const sidebarItems = [
    { path: "/seller-dashboard", label: "Dashboard" },
    { path: "/seller-deals", label: "Deals" },
    { path: "/seller-orders", label: "Orders" },
    { path: "/seller-notifications", label: "Notifications" },
    { path: "/seller-setting", label: "Setting" },
  ];

  const currentPage = sidebarItems.find(
    (item) => item.path === location.pathname
  );

  // Seller Panel breadcrumb — dashboard par khud ko repeat nahi karta
  const breadcrumbs =
    currentPage && currentPage.path !== "/seller-dashboard"
      ? [
          { label: "Seller Panel", href: "/seller-dashboard" },
          { label: currentPage.label, href: currentPage.path },
        ]
      : [{ label: "Seller Panel", href: "/seller-dashboard" }];

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setAuthToken(authToken);
    const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
    setLoggedInSeller(seller);
  }, []);

  return (
    // CHANGE 1: Container/Row/Col hata kar AdminMasterLayout jaisa plain wrapper diya —
    // agar SellerSideBar.css mein bhi "position: fixed" hai (jaisa AdminSideBar mein tha),
    // to Col ka reserved-width wala gray gap yahan bhi hota
    <div className="seller-layout-wrapper">
      <SellerSideBar />

      {/* CHANGE 2: content area ko "seller-content" class di — margin-left CSS file mein handle hoga */}
      <div className="seller-content">
        <div className="pt-2">
          <SellerTopBar
            title={currentPage?.label ?? selectedScreenOfSellerDashboardSidebar}
            breadcrumbs={breadcrumbs}
          />
        </div>

        <div className="mt-3">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SellerMasterLayout;